module.exports = __webpack_public_path__ + "img/icon-packages.fd95f9e0.svg";